'use client';
import { styled } from '@mui/material/styles';
import MuiSlider, { SliderProps } from '@mui/material/Slider';

const StyledSlider = styled(MuiSlider)<SliderProps>({});

export const RangeSlider = (props: SliderProps) => <StyledSlider {...props} />;
